/* eslint-disable react/prefer-stateless-function */

import React from 'react';
import ReactModal from 'react-modal';

import validateEmail from 'bl/validation/validateEmail.bl';

class EmailPopUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      emailErrorMessage: '',
    };
  }

  sendEmail = () => {
    if (validateEmail({ value: this.state.email })) {
      this.props.onSendEmail(this.state.email);
    }
  };

  validateEmail = (email) => {
    const value = email || this.state.email;

    if (validateEmail({ value })) {
      this.setState({ emailErrorMessage: '' });
    } else {
      this.setState({ emailErrorMessage: 'Please enter valid email' });
    }
  };

  render() {
    const styleError = {
      color: '#D32F2F',
      fontSize: '12px',
      textAlign: 'left',
      display: 'block',
      paddingTop: '8px',
      fontWeight: '600',
    };
    return (
      <ReactModal
        isOpen
        closeTimeoutMS={0}
        contentLabel="Some title"
        onRequestClose={this.props.onCancel}
        ariaHideApp={false}
        shouldCloseOnOverlayClick
        role="dialog"
        style={{
          overlay: {
            zIndex: 500,
          },
        }}
        className={{
          base: 'dialog-container',
          afterOpen: 'dialog-container',
          beforeClose: 'dialog-container',
        }}
      >
        <div className="dialog">
          <div className="dialog-header">
            <h2>Send Receipt</h2>
            <div className="close" role="button" tabIndex={0} onClick={this.props.onCancel}>
              <i className="zmdi zmdi-close zmdi-hc-2x" />
            </div>
          </div>
          <div className="body">
            {' '}
            <input
              id="email"
              className="input-default"
              type="text"
              onChange={(e) => {
                this.setState({ email: e.target.value });
              }}
              onBlur={(e) => {
                this.validateEmail(e.target.value);
              }}
              placeholder="Email"
              autoComplete="off"
            />
            {this.state.emailErrorMessage && <span style={styleError}>{this.state.emailErrorMessage}</span>}
          </div>
          <div className="dialog-footer">
            <div className="btn btn-violet-link" role="button" tabIndex={0} onClick={this.sendEmail}>
              Send
            </div>
          </div>
        </div>
      </ReactModal>
    );
  }
}

export default EmailPopUp;
